import $ from 'jquery';
import 'slick-carousel';
import SimpleParallax from "simple-parallax-js/vanilla";
import 'jquery-ui-dist/jquery-ui.js'
import 'jquery-ui-touch-punch/jquery.ui.touch-punch.js'

/* ==========================================================================
   Fade in elements with intersection observer
   ========================================================================== */

if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting === true) {
                entry.target.classList.add("fade-in--is-visible");
            } else {
                //entry.target.classList.remove("fade-in--is-visible");
            }
        });
    });
    var items = document.querySelectorAll(".fade-in");
    items.forEach(function (item, index) {
        observer.observe(item, index);
    });
} else {
    document.querySelector("body").classList.add("no-intersection-observer")
}

/* ==========================================================================
   Samson Mobile Menu Button
   ========================================================================== */

if (document.querySelector(".js-trigger-mobile-nav")) {
    $(".js-trigger-mobile-nav").click(function (e) {
        $(".samson-header").toggleClass("nav-is-active");
        $(this).toggleClass("is-active");
        $("body").toggleClass("lock-scroll");
        $(this).text($(this).text() == 'Close' ? 'Menu' : 'Close');
    });
}

/* ==========================================================================
   ForLease Mobile Menu Button
   ========================================================================== */

if (document.querySelector(".js-forlease-trigger-mobile-nav")) {
    $(".js-forlease-trigger-mobile-nav").click(function (e) {
        $(".forlease-nav").toggleClass("is-active");
        $(this).toggleClass("is-active");
        $(".js-toggle-fl-subnav").click()
    });
}

/* ==========================================================================
   ForLease Subnav Toggle Button
   ========================================================================== */

$(".js-toggle-fl-subnav").click(function (e) {
    e.preventDefault();
    var thisNav = $(this).parent().find(".forlease-subnav");
    $(".forlease-nav__link").not(this).removeClass("forlease-nav__link--subnav-active");
    $(".forlease-subnav").not(thisNav).fadeOut(250);
    $(this).toggleClass("forlease-nav__link--subnav-active");
    $(this).parent().find(".forlease-subnav").fadeToggle(250);
});

$(".js-close-fl-subnav").click(function (e) {
    e.preventDefault();
    $(".forlease-subnav").fadeOut(250);
    $(".forlease-nav__link").removeClass("forlease-nav__link--subnav-active");
});

/* ==========================================================================
   Custom Select
   ========================================================================== */

$(".custom-select").each(function () {
    let classes = $(this).attr("class");
    let template = '<div class="' + classes + '">';
    template += '<button class="custom-select-trigger">' + $(this).attr("placeholder") + '</button>';
    template += '<div class="custom-options">';
    $(this).find("option").each(function () {
        template += '<button class="custom-option ' + $(this).attr("class") + '" data-value="' + $(this).attr("value") + '">' + $(this).html() + '</button>';
    });
    template += '</div></div>';

    $(this).wrap('<div class="custom-select-wrapper column-4of12"></div>');
    $(this).hide();
    $(this).after(template);
});

$(".custom-option:first-of-type").hover(function () {
    $(this).parents(".custom-options").addClass("option-hover");
}, function () {
    $(this).parents(".custom-options").removeClass("option-hover");
});

$(".custom-select-trigger").on("click", function () {
    $('html').one('click', function () {
        $(".custom-select").removeClass("opened");
    });
    $(".custom-select-trigger").not(this).parents(".custom-select").removeClass("opened");
    $(this).parents(".custom-select").toggleClass("opened");
    event.stopPropagation();
});

$(".custom-option").on("click", function () {
    $(this).parents(".custom-select-wrapper").find("select").val($(this).data("value"));
    $(this).parents(".custom-options").find(".custom-option").removeClass("selection");
    $(this).addClass("selection");
    $(this).parents(".custom-select").removeClass("opened");
    $(this).parents(".custom-select").find(".custom-select-trigger").text($(this).text());

    // only trigger this for "download" specific custom select
    if ($(this).parents(".custom-select-wrapper").hasClass("custom-select-downloads") &&
        $(this).data("value").length) {
        window.open($(this).data("value"));
    }
});


/* ==========================================================================
   Custom multi select
   ========================================================================== */

$(".js-toggle-multiselect").click(function (e) {
    e.preventDefault();
    var thisMultiSelect = $(this).parent().find(".filters__multiselect-popup");
    $(".filters__multiselect-button").not(this).removeClass("filters__multiselect-button--active");
    $(".filters__multiselect-popup").not(thisMultiSelect).fadeOut(250);
    $(this).toggleClass("filters__multiselect-button--active");
    $(this).parent().find(".filters__multiselect-popup").fadeToggle(250);
});

$(".js-close-multiselect").click(function (e) {
    e.preventDefault();
    $(".filters__multiselect-popup").fadeOut(250);
    $(".filters__multiselect-button").removeClass("filters__multiselect-button--active");
});

/* ==========================================================================
   Accordion
   ========================================================================== */

$(document).ready(function ($) {
    $('.accordion').find('.accordion__toggle').click(function () {

        var isActive = $(this).hasClass("active");

        $('.accordion__toggle').removeClass('active')

        if (!isActive) {
            $(this).toggleClass('active');

        }

        $(this).next().slideToggle('fast');
        $(".accordion__content").not($(this).next()).slideUp('fast');

    });
});


/* ==========================================================================
   Slick Sliders
   ========================================================================== */

// ForLease Hero Slider
function flHeroSliderInit() {
    var $flHeroSlider = $('.forlease-hero-slider');
    $flHeroSlider.each(function () {
        var $flHeroSliderParent = $(this).parent();
        $(this).slick({
            fade: true,
            dots: false,
            arrows: true,
            prevArrow: '<button class="slick-prev slick-arrow"><span class="screen-reader-text">Previous slide</span> <svg class="icon" role="presentation"><use xlink:href="#caret-left"></use></svg></button>',
            nextArrow: '<button class="slick-next slick-arrow"><span class="screen-reader-text">Next slide</span> <svg class="icon" role="presentation"><use xlink:href="#caret-right"></use></svg></button>',
            appendArrows: $(".forlease-hero-slider-controls__append")
        });

        $(this).on('afterChange', function (event, slick, currentSlide) {
            $flHeroSliderParent.find('.forlease-hero-slider-controls__counter .active').html(currentSlide + 1);
        });

        var flHeroSliderItemsNum = $(this).find('.slick-slide').not('.slick-cloned').length;
        $flHeroSliderParent.find('.forlease-hero-slider-controls__counter .total').html(flHeroSliderItemsNum);

    });
};

flHeroSliderInit();

// ForLease Property Slider
function flPropertySliderInit() {
    var $flPropertSlider = $('.forlease-property-gallery-slider');
    $flPropertSlider.each(function () {
        var $flPropertySliderParent = $(this).parent();
        $(this).slick({
            fade: true,
            dots: false,
            arrows: true,
            prevArrow: '<button class="slick-prev slick-arrow"><span class="screen-reader-text">Previous slide</span> <svg class="icon" role="presentation"><use xlink:href="#caret-left"></use></svg></button>',
            nextArrow: '<button class="slick-next slick-arrow"><span class="screen-reader-text">Next slide</span> <svg class="icon" role="presentation"><use xlink:href="#caret-right"></use></svg></button>',
            appendArrows: $(".forlease-property-gallery-slider__arrows")
        });

        $(this).on('afterChange', function (event, slick, currentSlide) {
            $flPropertySliderParent.find('.forlease-property-gallery-slider__counter .active').html(currentSlide + 1);
        });

        var flPropertySliderItemsNum = $(this).find('.slick-slide').not('.slick-cloned').length;
        $flPropertySliderParent.find('.forlease-property-gallery-slider__counter .total').html(flPropertySliderItemsNum);

    });
};

flPropertySliderInit();

$('.forlease-property-gallery-slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    $("video").each(function () {
        this.pause();
    });
});

/* ==========================================================================
   Parallax Scrolling Images
   ========================================================================== */

var image = document.getElementsByClassName('parallax');
new SimpleParallax(image, {
    delay: 0,
    scale: 1.5,
    orientation: 'down'
});

/* ==========================================================================
   App Height
   ========================================================================== */

function appHeight() {
    const doc = document.documentElement
    doc.style.setProperty('--vh', (window.innerHeight * .01) + 'px');
}

window.addEventListener('resize', appHeight);
appHeight();

/* ==========================================================================
   Jquery UI - Range Slider
   ========================================================================== */

$(".js-range-slider").each(function () {
    var $this = $(this);
    $this.slider({
        range: true,
        step: 50,
        min: $this.data("min"),
        max: $this.data("max"),
        values: [$this.data("low"), $this.data("high")],
        slide: function (event, ui) {
            var $slider = $(event.target);
            $slider.siblings(".range-values--min").html(ui.values[0] + "m2")
            $slider.siblings(".range-values--max").html(ui.values[1] + "m2")
        }
    });
    $this.siblings(".range-values--min").html($this.slider("values", 0) + "m2");
    $this.siblings(".range-values--max").html($this.slider("values", 1) + "m2")
});

$(".forlease-hero-slider-filters__item").on("mouseenter", function () {
    $(this).closest(".forlease-hero-slider").slick("slickGoTo", $(this).data("index"));
});


/* ==========================================================================
Animated Body Background Color on Scroll through sections
========================================================================== */

if ('IntersectionObserver' in window) {
    var backgroundObserverOptions;
    if (window.matchMedia("(min-height: 1400px)").matches) {
        backgroundObserverOptions = {
            root: null,
            rootMargin: '0px 0px',
            threshold: 0.75,
        };
    } else if (window.matchMedia("(min-height: 800px)").matches) {
        backgroundObserverOptions = {
            root: null,
            rootMargin: '0px 0px',
            threshold: 0.30,
        };
    } else {
        backgroundObserverOptions = {
            root: null,
            rootMargin: '0px 0px',
            threshold: 0.15,
        };
    }
    var backgroundObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                $('body').removeClass(function (index, css) {
                    return (css.match(/(^|\s)background__\S+/g) || []).join(' ');
                });
                $('body').addClass('background__' + entry.target.dataset["color"]);
            } else {
            }
        });
    }, backgroundObserverOptions);
    var items = document.querySelectorAll(".animate-background");
    items.forEach(function (item, index) {
        backgroundObserver.observe(item, index);
    });
}


/* ==========================================================================
Hover image menu - modified from: https://tympanus.net/codrops/2018/11/27/image-reveal-hover-effects/
========================================================================== */

{
    const getMousePos = (e) => {
        let posx = 0;
        let posy = 0;
        if (!e) e = window.event;
        if (e.pageX || e.pageY) {
            posx = e.pageX;
            posy = e.pageY;
        }
        else if (e.clientX || e.clientY) {
            posx = e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
            posy = e.clientY + document.body.scrollTop + document.documentElement.scrollTop;
        }
        return { x: posx, y: posy }
    }

    class HoverImgFx1 {
        constructor(el) {
            this.DOM = { el: el };
            this.DOM.reveal = document.createElement('div');
            this.DOM.reveal.className = 'hover-reveal';
            this.DOM.reveal.innerHTML = `<div class="hover-reveal__inner"><div class="hover-reveal__image"><img src="${this.DOM.el.dataset.img}" width=""/></div></div>`;
            this.DOM.el.parentElement.parentElement.appendChild(this.DOM.reveal);
            this.DOM.revealInner = this.DOM.reveal.querySelector('.hover-reveal__inner');
            this.DOM.revealInner.style.overflow = 'hidden';
            this.DOM.revealImg = this.DOM.revealInner.querySelector('.hover-reveal__image');

            this.initEvents();
        }
        initEvents() {
            this.positionElement = (ev) => {
                const mousePos = getMousePos(ev);
                const docScrolls = {
                    left: document.body.scrollLeft + document.documentElement.scrollLeft,
                    top: document.body.scrollTop + document.documentElement.scrollTop
                };
                this.DOM.reveal.style.top = `${mousePos.y + 20 - docScrolls.top}px`;
                this.DOM.reveal.style.left = `${mousePos.x + 20 - docScrolls.left}px`;
            };
            this.mouseenterFn = (ev) => {
                this.positionElement(ev);
                this.showImage();
            };
            this.mousemoveFn = ev => requestAnimationFrame(() => {
                this.positionElement(ev);
            });
            this.mouseleaveFn = () => {
                this.hideImage();
            };

            this.DOM.el.addEventListener('mouseenter', this.mouseenterFn);
            this.DOM.el.addEventListener('mousemove', this.mousemoveFn);
            this.DOM.el.addEventListener('mouseleave', this.mouseleaveFn);
        }
        showImage() {
            this.DOM.reveal.style.opacity = 1;
        }
        hideImage() {
            this.DOM.reveal.style.opacity = 0;
        }
    }

    if (window.matchMedia("(hover)").matches) {
        [...document.querySelectorAll('.image-hover-menu__link')].forEach(link => new HoverImgFx1(link));
    }

}
